import { initializeApp, deleteApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { firebaseConfig } from '../firebase';

// Creates a Firebase Auth account WITHOUT signing out the current admin.
// The default app's createUserWithEmailAndPassword switches currentUser to the
// new account, which would log the admin out mid-session — so we use a
// secondary app instance and dispose of it afterwards.
export async function createUserAsAdmin(email, password) {
  const secondaryApp = initializeApp(firebaseConfig, `user-create-${Date.now()}`);
  try {
    const secondaryAuth = getAuth(secondaryApp);
    const credential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
    const uid = credential.user.uid;
    await signOut(secondaryAuth);
    return uid;
  } finally {
    deleteApp(secondaryApp).catch(() => {});
  }
}
